<template>
        <div class="accident-add-block">
            <input type="hidden"
                :name="'accident[' + service.category_id + ']['+  service.accident_id +'][sort_no]'"
                v-model="service.sort_no">

            <div class="nowrap drag_handle"><i class="fa fa-align-justify"></i></div>
            <div class="accident-add-block__inner">
                <div class="post-check-box">
                    <label class="post-check-box__label">
                        <input type="checkbox" :name="'accident[' + service.category_id + ']['+  service.accident_id +'][item_public_flg]'" v-model="service.item_public_flg">
                        &ensp;掲載する
                    </label>
                </div>
                <div class="accident-add-block__top">
                    <div class="accident-contant-name">
                        <div class="contact-name">
                            <p>連絡先名</p>
                            <span class="label-danger">必須</span>
                        </div>
                        <input class="form-control contact-name-input" type="text"
                            :name="'accident[' + service.category_id + ']['+  service.accident_id +'][accident_contact_name]'"
                            :id="'service_name_' + service.accident_id"
                            v-model="service.accident_contact_name" maxlength="255" placeholder="例）◯◯保険会社名">
                        <div v-if="errors.accident_errors">
                            <div v-if="errors.accident_errors.accident_contact_name[service.category_id][service.accident_id]">
                                <p class="service_error" v-show="errors.accident_errors.accident_contact_name[service.category_id][service.accident_id]"
                                style="display: none">連絡先名が未入力です。</p>
                            </div>
                        </div>
                    </div>
                    <div class="accident-contact-type">
                        <p>連絡先種別</p>
                        <input class="form-control accident-contact-type-input" type="text"
                        :name="'accident[' + service.category_id + ']['+  service.accident_id +'][accident_contact_type]'"
                        :id="'service_contact_type_' + service.accident_id"
                        v-model="service.accident_contact_type" maxlength="255"
                        placeholder="例）自動車事故受付"></input>
                        &ensp;
                    </div>
                    <div class="accident-contact-tel">
                        <p>TEL</p>
                        <input class="form-control accident-contact-tel-input" type="text"
                            :name="'accident[' + service.category_id + ']['+  service.accident_id +'][accident_tel]'"
                            :id="'service_accident_tel_' + service.accident_id"
                            v-model="service.accident_tel" maxlength="255"
                            placeholder="例）00-0000-0000">
                        </input>
                    </div>
                </div>
                <div class="accident-add-block__bottom">
                    <div class="accident-supplementary-txt">
                        <p>補足テキスト</p>
                        <textarea rows="3"
                        :name="'accident[' + service.category_id + ']['+  service.accident_id +'][accident_notes]'"
                        :id="'service_accident_notes_' + service.accident_id"
                        class="form-control"
                        v-model="service.accident_notes" maxlength="255"
                        placeholder="受付時間や特記事項など"></textarea>
                    </div>
                    <div class="accident-site-link">
                        <label class="">
                            <input type="checkbox"
                                :name="'accident[' + service.category_id + ']['+  service.accident_id +'][accident_link_flg]'"
                                v-model="service.accident_link_flg">&ensp;Webサイトリンク設置
                        </label>
                        <input class="form-control" type="text"
                            :name="'accident[' + service.category_id + ']['+  service.accident_id +'][accident_link]'"
                            :id="'service_accident_link_' + service.accident_id"
                            v-model="service.accident_link" maxlength="255"
                            placeholder="例）https://~">
                        </input>
                    </div>
                </div>
            </div>
            <div class="no_dragover accident-contact-delete">
                <a class="btn-delete" data-toggle="modal"
                    :data-target="'#dialog_delete_item_'+ accident_key + '_' + service.accident_id">
                <button class="btn btn-primary btn-xs" type="button"
                        v-if="(service_key != '0')">
                    <i class="fa fa-trash"></i>
                    削除
                </button>
                </a>
            </div>
            <!-- 削除ダイアログ -->
            <div class="modal fade inmodal" role="dialog"
                    :id="'dialog_delete_item_'+ accident_key + '_' + service.accident_id" tabindex="-1">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal"
                                    aria-label="Close"><span aria-hidden="true">×</span></button>
                            <i class="fa fa-trash modal-icon"></i>
                            <h4 class="modal-title">削除の確認</h4>
                        </div>
                        <div class="modal-body">
                            <p v-show="service.accident_contact_name">『{{ service.accident_contact_name }}』を削除してもよろしいですか？</p>
                            <p v-show="!service.accident_contact_name">該当の連絡先を削除してもよろしいですか？</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default pull-left"
                                    data-dismiss="modal">キャンセル
                            </button>
                            <button type="button" class="btn btn-primary"
                                    @click="emitEvent(accident_key,service_key, '#dialog_delete_item_'+ accident_key + '_' + service.accident_id)">
                                実行する
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>

export default {
    props: ['service', 'service_key', 'accident_key', 'errors'],
    methods: {
        emitEvent(accident_key, service_key, modal_name) {
            this.$emit('service-emit', {accident_key: accident_key, service_key: service_key, modal_name: modal_name })
        }
    }
}
</script>
